import i18next from "i18next";

export const EPublicRoutes = {
  get HOME() {
    return i18next.t("routes.public.home", { defaultValue: "/" });
  },

  get BLOGS() {
    return i18next.t("routes.public.blogs", { defaultValue: "/blog" });
  },

  get SMURFS_RANKED() {
    return i18next.t("routes.public.smurfs_ranked", {
      defaultValue: "/ranked",
    });
  },
  get SMURFS_HANDLEVEL() {
    return i18next.t("routes.public.smurfs_handlevel", {
      defaultValue: "/handlevel",
    });
  },
  get SMURFS_NORMAL() {
    return i18next.t("routes.public.smurfs_normal", {
      defaultValue: "/normal",
    });
  },
  get SMURFS_SKIN() {
    return i18next.t("routes.public.smurfs_skin", { defaultValue: "/skin" });
  },

  get VALORANT() {
    return i18next.t("routes.public.valorant", {
      defaultValue: "/acheter-compte-valorant",
    });
  },

  get BASKET() {
    return i18next.t("routes.public.basket", { defaultValue: "/panier" });
  },
  get ORDER() {
    return i18next.t("routes.public.order", { defaultValue: "/commande" });
  },

  get FAQ() {
    return i18next.t("routes.public.faq", { defaultValue: "/faq-support" });
  },
  get FAQ_CHANGE_EMAIL() {
    return i18next.t("routes.public.faq_change_email", {
      defaultValue:
        "/faq-support/comment-changer-l-e-mail-et-le-mot-de-passe-sur-league-of-legends",
    });
  },
  get FAQ_CHANGE_RIOT_ID() {
    return i18next.t("routes.public.faq_change_riot_id", {
      defaultValue:
        "/faq-support/comment-changer-l-id-riot-et-le-nom-de-l-invocateur",
    });
  },
  get FAQ_GET_SKINS() {
    return i18next.t("routes.public.faq_get_skins", {
      defaultValue:
        "/faq-support/comment-debloquer-des-skins-avec-des-eclats-de-skins-sur-lol",
    });
  },
  get FAQ_CANNOT_BUY_CHAMPIONS() {
    return i18next.t("routes.public.faq_cannot_buy_champions", {
      defaultValue: "/faq-support/je-ne-peux-pas-acheter-de-champions",
    });
  },
  get FAQ_SAVE_SETTINGS() {
    return i18next.t("routes.public.faq_save_settings", {
      defaultValue: "/faq-support/sauvegardez-vos-settings-sur-tous-vos-smurfs",
    });
  },
  get FAQ_ACCOUNT_BANNED() {
    return i18next.t("routes.public.faq_account_banned", {
      defaultValue: "/faq-support/mon-compte-est-banni-que-faire",
    });
  },

  get CGV() {
    return i18next.t("routes.public.cgv", {
      defaultValue: "/conditions-générales-de-vente",
    });
  },
  get PC() {
    return i18next.t("routes.public.pc", {
      defaultValue: "/politique-de-confidentialité",
    });
  },
  get REVIEWS() {
    return i18next.t("routes.public.reviews", {
      defaultValue: "/avis",
    });
  },

  get NOT_FOUND() {
    return "/404";
  },

  get AUTH_DISCORD() {
    return "/auth/discord/callback";
  },
  get AUTH_GOOGLE() {
    return "/auth/google/callback";
  },
};

export const EExternalRoutes = {
  get DISCORD() {
    return i18next.t("routes.external.discord", {
      defaultValue: "https://discord.com/invite/Rhvvt8P53s",
    });
  },
  get TWITTER() {
    return i18next.t("routes.external.twitter", {
      defaultValue: "https://x.com/SECRETSMURFSGG",
    });
  },
  get TRUSTPILOT_REVIEWS() {
    return i18next.t("routes.external.trustpilot_review", {
      defaultValue: "https://fr.trustpilot.com/review/secretsmurfs.gg",
    });
  },
  get TRUSTPILOT_EVALUATE() {
    return i18next.t("routes.external.trustpilot_evaluate", {
      defaultValue: "https://fr.trustpilot.com/evaluate/secretsmurfs.gg",
    });
  },
};

export const AUTH_URL_PREFIX = "/auth";

export const EPrivateRoutes = {
  get ORDERS() {
    return i18next.t("routes.private.orders", { defaultValue: "/auth/orders" });
  },
  get FIDELITY() {
    return i18next.t("routes.private.fidelity", {
      defaultValue: "/auth/fidelity",
    });
  },
  get AFFILIATION() {
    return i18next.t("routes.private.affiliation", {
      defaultValue: "/auth/affiliation",
    });
  },
  get REWARDS() {
    return i18next.t("routes.private.rewards", {
      defaultValue: "/auth/rewards",
    });
  },
  get HELP() {
    return i18next.t("routes.private.help", { defaultValue: "/auth/help" });
  },
};

export default EPublicRoutes;
